// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { TextMode } from "./text-mode";

export class TextDecode implements flatbuffers.IUnpackableObject<TextDecodeT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): TextDecode {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsTextDecode(bb: flatbuffers.ByteBuffer, obj?: TextDecode): TextDecode {
    return (obj || new TextDecode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsTextDecode(bb: flatbuffers.ByteBuffer, obj?: TextDecode): TextDecode {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new TextDecode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  mode(): TextMode {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : TextMode.NulTerminatedAscii;
  }

  static startTextDecode(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addMode(builder: flatbuffers.Builder, mode: TextMode) {
    builder.addFieldInt8(0, mode, TextMode.NulTerminatedAscii);
  }

  static endTextDecode(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createTextDecode(builder: flatbuffers.Builder, mode: TextMode): flatbuffers.Offset {
    TextDecode.startTextDecode(builder);
    TextDecode.addMode(builder, mode);
    return TextDecode.endTextDecode(builder);
  }

  unpack(): TextDecodeT {
    return new TextDecodeT(this.mode());
  }

  unpackTo(_o: TextDecodeT): void {
    _o.mode = this.mode();
  }

  unpackFields(...fields: string[]): TextDecodeT {
    const t = new TextDecodeT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("mode")) {
      t.mode = this.mode();
    }
    return t;
  }
}

export class TextDecodeT implements flatbuffers.IGeneratedObject {
  constructor(public mode: TextMode = TextMode.NulTerminatedAscii) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return TextDecode.createTextDecode(builder, this.mode);
  }

  clone(): TextDecodeT {
    const obj = new TextDecodeT();
    obj.mode = this.mode;
    return obj;
  }

  equals(other: TextDecodeT): boolean {
    if (this.mode !== other.mode) return false;
    return true;
  }
}

export function verifyTextDecode(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
  } finally {
    verifier.popDepth();
  }
}
